import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.number.is-nan";
import _classCallCheck from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * 通用工具类
 */
var func = /*#__PURE__*/function () {
  function func() {
    _classCallCheck(this, func);
  }

  _createClass(func, null, [{
    key: "notEmpty",

    /**
     * 不为空
     * @param val
     * @returns {boolean}
     */
    value: function notEmpty(val) {
      return !this.isEmpty(val);
    }
    /**
     * 是否为定义
     * @param val
     * @returns {boolean}
     */

  }, {
    key: "isUndefined",
    value: function isUndefined(val) {
      return val === null || typeof val === 'undefined';
    }
    /**
     * 为空
     * @param val
     * @returns {boolean}
     */

  }, {
    key: "isEmpty",
    value: function isEmpty(val) {
      if (val === null || typeof val === 'undefined' || typeof val === 'string' && val === '' && val !== 'undefined') {
        return true;
      }

      return false;
    }
    /**
     * 强转int型
     * @param val
     * @param defaultValue
     * @returns {number}
     */

  }, {
    key: "toInt",
    value: function toInt(val, defaultValue) {
      if (this.isEmpty(val)) {
        return defaultValue === undefined ? -1 : defaultValue;
      }

      var num = parseInt(val, 0);
      return Number.isNaN(num) ? defaultValue === undefined ? -1 : defaultValue : num;
    }
    /**
     * Json强转为Form类型
     * @param obj
     * @returns {FormData}
     */

  }, {
    key: "toFormData",
    value: function toFormData(obj) {
      var data = new FormData();
      Object.keys(obj).forEach(function (key) {
        data.append(key, Array.isArray(obj[key]) ? obj[key].join(',') : obj[key]);
      });
      return data;
    }
    /**
     * date类转为字符串格式
     * @param date
     * @param format
     * @returns {null}
     */

  }, {
    key: "format",
    value: function format(date) {
      var _format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';

      return date ? date.format(_format) : null;
    }
    /**
     * 根据逗号联合
     * @param arr
     * @returns {string}
     */

  }, {
    key: "join",
    value: function join(arr) {
      return arr ? arr.join(',') : '';
    }
    /**
     * 根据逗号分隔
     * @param str
     * @returns {string}
     */

  }, {
    key: "split",
    value: function split(str) {
      return str ? String(str).split(',') : '';
    }
  }]);

  return func;
}();

export { func as default };